import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useSelector, useDispatch } from "react-redux";
import { actions as menuActions } from "@store/menu/reducer";
import "./style.css";
import { Divider } from "@mui/material";

function SubCategoryTabList(props) {
  const { menu, selectedTab, selectedSubCategoryTab } = useSelector(
    (state) => state.menu
  );
  const dispatch = useDispatch();

  const handleChange = (event, newValue) => {
    dispatch(menuActions.updateSelectedSubCategoryTab(newValue));
  };
  const selectedCategory = menu?.categories[selectedTab];

  if (selectedCategory?.categories?.length <= 1) {
    return null;
  }

  return (
    <>
      <Divider sx={{ marginBottom: "10px" }} />
      <Box
        sx={{ bgcolor: "background.paper", marginBottom: "" }}
        className="categories"
      >
        <Tabs
          value={selectedSubCategoryTab}
          onChange={handleChange}
          variant="scrollable"
          aria-label="scrollable prevent tabs example"
          scrollButtons
          allowScrollButtonsMobile
        >
          {selectedCategory?.categories?.map((category) => (
            <Tab
              label={category.name}
              {...a11yProps(category.categoryId)}
              key={category.categoryId}
            />
          ))}
        </Tabs>
      </Box>
    </>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default SubCategoryTabList;
